export const ProductIcon = ({ color = "#0F2C52" }: { color?: string }) => {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1571_5341)">
        <path
          d="M1.75 3.9375H12.25C12.25 3.9375 13.125 3.9375 13.125 4.8125V12.6875C13.125 12.6875 13.125 13.5625 12.25 13.5625H1.75C1.75 13.5625 0.875 13.5625 0.875 12.6875V4.8125C0.875 4.8125 0.875 3.9375 1.75 3.9375Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.0084 4.375L11.6084 0.957253C11.5395 0.802264 11.4271 0.670626 11.2848 0.578351C11.1425 0.486076 10.9765 0.437143 10.8069 0.437503H3.19378C3.02409 0.43703 2.85792 0.48591 2.71551 0.578192C2.5731 0.670473 2.46059 0.802173 2.3917 0.957253L0.991699 4.375"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 3.9375V0.4375"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.3125 10.9375H10.9375"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1571_5341">
          <rect width="14" height="14" fill={color} />
        </clipPath>
      </defs>
    </svg>
  );
};
